import React, { useState } from "react";
import { Tooltip } from "@fluentui/react-components";
import { FolderRegular } from "@fluentui/react-icons";
import TruncatedFolderPath from "../TruncatedFolderPath";
import { filedFolderClass, filedFolderPathClass, filedFolderLabelClass } from "../styles";

type Props = {
  segments: string[];
  tooltipContent: string;
};

const FiledFolderPath: React.FC<Props> = ({ segments, tooltipContent }) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const [hovered, setHovered] = useState(false);

  // The tooltip is only useful when the displayed text differs from the full path,
  // i.e. when it was truncated with "...". A folder shown in full (e.g. "Inbox")
  // has nothing extra to reveal. We fully control `visible` so the Tooltip stays
  // mounted (the measured subtree never remounts, which would loop the truncation
  // calc) and hover behaviour stays deterministic.
  const canShowTooltip = isTruncated;

  return (
    <Tooltip
      content={tooltipContent}
      relationship="label"
      visible={canShowTooltip && hovered}
      onVisibleChange={(_, data) => setHovered(data.visible)}
    >
      <span className={`${filedFolderClass} ${filedFolderPathClass}`}>
        <FolderRegular />
        <TruncatedFolderPath
          segments={segments}
          className={filedFolderLabelClass}
          onTruncatedChange={setIsTruncated}
        />
      </span>
    </Tooltip>
  );
};

export default FiledFolderPath;
